export const isInFeatureConfigCIMode = (): boolean =>
  process.env.WF_FEATURE_CONFIG_CI_MODE === 'true' ||
  (typeof window !== 'undefined' &&
    (window as any)?.wfenvironment?.WF_FEATURE_CONFIG_CI_MODE === 'true');

export const isTestEnv = (): boolean => {
  if (isInFeatureConfigCIMode()) {
    return true;
  }

  if (process.env.APP_ENV !== undefined) {
    return process.env.APP_ENV === 'test';
  }

  return process.env.NODE_ENV === 'test';
};
